import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, Redirect } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';
import Cookies from 'js-cookie';


const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const SignUp = lazy(() => import('../container/profile/authentication/overview/Signup'));
const ForgotPass = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

const NotFound = () => {
  return <Redirect to="/" />;
};

const ForceLogout = () => {
  Cookies.remove('dcare_logedIn');
  Cookies.remove('dcare_access_token');
  Cookies.remove('dcare_user');
  document.location.href = REACT_APP_BASE_URL;
};

const FrontendRoutes = () => {
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route exact path="/forgotPassword" component={ForgotPass} />
        <Route exact path="/register" component={SignUp} />
        <Route exact path="/" component={Login} />
        <Route exact path="*" component={NotFound} />
        <Route exact path="/cerrar" component={ForceLogout} />
      </Suspense>
    </Switch>
  );
};

export default AuthLayout(FrontendRoutes);
